export const STARKNET_BLOCK_POLLING = 5000 // 5s
